import { CurrencyString } from "../types/product";

export function formatCurrency(value: number, currency: CurrencyString) {
  if (value === undefined) return undefined;
  return getCurrencyFormatter(currency)?.format(value);
}

function getCurrencyFormatter(currency: CurrencyString) {
  switch (currency) {
    case "HKD":
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HKD",
      });
    case "CNY":
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currencyDisplay: "narrowSymbol",
        currency: "CNY",
      });
    case "USD":
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
    case "GBP":
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "GBP",
      });
  }
}
